module.exports = __webpack_public_path__ + "static/Kaizen_MetaisBasicosAN-c427d8f9d10abedc8adcdc338fc2ef8e.jpg";